import { useNavigate } from "react-router-dom";

export default function BackToSetting() {
    const navigate = useNavigate();

    return(
        <div className="back-arrow flex-center">
            <button aria-label="back" onClick={() => navigate("/settings")}>
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13" fill="none">
            <path d="M0.46967 5.96967C0.176777 6.26256 0.176777 6.73744 0.46967 7.03033L5.24264 11.8033C5.53553 12.0962 6.01041 12.0962 6.3033 11.8033C6.59619 11.5104 6.59619 11.0355 6.3033 10.7426L2.06066 6.5L6.3033 2.25736C6.59619 1.96447 6.59619 1.48959 6.3033 1.1967C6.01041 0.903806 5.53553 0.903806 5.24264 1.1967L0.46967 5.96967ZM1 7.25H14V5.75H1V7.25Z" fill="#1D4ED8"/>
            </svg>
            </button>
            <span>Back to Settings</span>
        </div>
    );
}